<div class="flex" *ngIf="tasks?.length || loading">
  <div class="panel-left">
    <div #tasksList
         (infiniteReached)="loadMore()"
         [distance]="size"
         [enabled]="tasks.length < total || loading"
         class="workflows-list"
         gp-infinite-scroll
         test-id="tasks-in-progress">
      <div *ngFor="let task of tasks trackBy: trackByTaskId"
           [class.pointer]="task.status === 'IN_PROGRESS'"
           (click)="viewTask(task)"
           class="workflow-cell">
        <div class="col-xs-9 workflow-cell--description">
          <div class="workflow-cell--title">
            <span class="workflow-cell-read--indicator" *ngIf="!task?.read"></span>
            {{ task?.translationKeys.title | translate | translateAndFormatVariables: task.variables: (trigger$|async) }}
          </div>
          <div class="workflow-cell--subtitle">
            {{ task?.translationKeys.subtitle | translate | translateAndFormatVariables: task.variables: (trigger$|async) }}
          </div>
        </div>
        <div class="col-xs-3 workflow-cell--extra">
          <gp-workflow-status [status]="task.status"></gp-workflow-status>
          <div class="m-t-xs">{{ 'WORKFLOWS.ended_on'| translate }}
            <span>{{ task?.endTime ? (task?.endTime | gpDate: {} : (trigger$|async)) : '---' }}</span>
            <span *ngIf="isCanceled(task)" class="opacity-3">
              ({{ 'WORKFLOWS.canceled'| translate }})
            </span>
            <span *ngIf="isDeleted(task)" class="opacity-3">
              ({{ 'WORKFLOWS.deleted'| translate }})
            </span>
          </div>
          <div *ngIf="task?.startTime">
            {{ 'WORKFLOWS.started_on' | translate }} {{ task?.startTime | gpDate: {} : (trigger$|async) }}
          </div>
          <div *ngIf="task.isFallbackRecipient" class="workflow-cell--default-recipient text-xs"
               tooltip="{{'INBOX.default_recipient'|translate}}">
            <em class="fa fa-light fa-user-check"></em>
          </div>
        </div>
      </div>
      <div *ngIf="loading" class="p-x-sm">
        <p>
          <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
        </p>
        <p>
          <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
        </p>
        <p>
          <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
        </p>
      </div>
    </div>
  </div>
  <div class="panel-right">
    <router-outlet></router-outlet>
  </div>
</div>
<gp-illustrated-message [width]="'30%'" *ngIf="!loading && !tasks.length" [text]="'WORKFLOWS.no_task'"></gp-illustrated-message>

